/**
 * Procedure Categories and Procedures for DM in Neonatology students
 * Extracted with strict evidence from official NMC PDF (Page 5, 8: "Psychomotor domain - Must know skills perform independently")
 */
export const NEONATOLOGY_PROCEDURES = {
  "Neonatal Resuscitation, Airway & Respiratory Support Procedures": [
    "Neonatal Resuscitation (NALS / NRP Guidelines) & Orotracheal Intubation (<750g & VLBW Neonates)",
    "Surfactant Administration & Endotracheal Delivery",
    "Application & Management of CPAP (Continuous Positive Airway Pressure)",
    "Invasive Mechanical Ventilation & High-Frequency Ventilation (HFV)",
    "Intercostal Chest Drain Insertion (Chest Tube Placement)",
    "Independent & Safe Neonatal Transport (Intra-Hospital & Inter-Hospital)",
  ],
  "Vascular Access, Transfusion & Invasive Neonatal Procedures": [
    "Peripheral Intravenous & Peripheral Arterial Cannulation (Arterial Line Placement)",
    "Percutaneously Inserted Central Catheter (PICC Line) Insertion",
    "Umbilical Venous Catheter (UVC) & Umbilical Arterial Catheter (UAC) Placement",
    "Partial & Double Volume Exchange Transfusion",
    "Lumbar Puncture & Diagnostic Cerebrospinal Fluid (CSF) Sampling",
    "Suprapubic Bladder Puncture & Urine Sampling",
    "Total Parenteral Nutrition (TPN) Preparation & Administration",
    "Therapeutic Hypothermia Protocol Execution for Neonatal Encephalopathy",
  ],
  "Diagnostic Neonatal Ultrasonography & Bedside Lab Procedures": [
    "Point-of-Care Cranial Ultrasonography (Neurosonogram)",
    "Functional Neonatal Echocardiography (Functional ECHO)",
    "Bedside Neonatal Lab Microscopy, Blood Gas (ABG) & Spectrophotometric Bilirubin Analysis",
  ],
};

export const NEONATOLOGY_CATEGORIES = Object.keys(NEONATOLOGY_PROCEDURES);

export const isDMInNeonatologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("neonatology") || d.includes("neonatal");
};
